var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272.727,
    height: 60,
    viewBox: "0 0 272.727 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD569\\uCE58\\uAE30 231",
    d: "M235.2 60h-12.51V.008h47.54v10H235.2v15h32.527V35H235.2v15h37.531v10zm-40.034 0V15.006L175.146 30V15L155.13 30V15l20.017-15v15l20.016-15h12.511v60zm-90.074 0L93.078 40H77.565v20H65.054V.008h30.025a19.988 19.988 0 0 1 9.158 37.77L117.6 60zM77.565 27.5h17.514a7.5 7.5 0 1 0 0-15H77.565zM0 60V.008h30.025a20 20 0 1 1 0 39.994H12.51V60zm12.51-32.5h17.515a7.5 7.5 0 1 0 0-15H12.51zm117.844 32.255V0h12.257v59.755z",
    style: {
      fill: "#101010"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesLogo1);
export default __webpack_public_path__ + "static/media/features-logo-1.ce688f8df0a6607b4bf6a8ca308b4f54.svg";
export { ForwardRef as ReactComponent };